import LogRocket from 'logrocket';

import { VERSION } from '../constants/environment';

export function getRequestHeaders() {
  const headers: Record<string, string> = {};

  // Always include AppName and AppVersion headers
  headers.AppName = 'Backoffice';
  if (VERSION) {
    headers.AppVersion = VERSION ?? '';
  }

  const logRocketSessionUrl = LogRocket.sessionURL;
  if (logRocketSessionUrl) {
    headers['X-LogRocket-URL'] = logRocketSessionUrl;
  }

  return headers;
}
